import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import { ReactElement } from "react";

import classes from "./FilterAgentForm.module.css";

/**
 * Форма фильтрации агентов.
 */
export function FilterAgentForm(): ReactElement {
  const [form] = useForm();
  return (
    <Form
      className={classes.form}
      form={form}
      autoComplete="off"
      name="filter_applications"
    >
      <Form.Item noStyle={true}>
        <Input
          className={classes.form__item}
          size="large"
          placeholder="ООО, ИП"
          suffix={<SearchOutlined className={classes.form__searchIcon} />}
          allowClear
        />
      </Form.Item>

      <Form.Item noStyle={true}>
        <Input
          className={classes.form__item}
          size="large"
          placeholder="ИНН"
          suffix={<SearchOutlined className={classes.form__searchIcon} />}
          allowClear
        />
      </Form.Item>

      <Button className={classes.form__resetButton} type="primary">
        Сбросить фильтр
        <CloseOutlined className={classes.form__buttonIcon} />
      </Button>
    </Form>
  );
}
